// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"296b4a7c","351":"019b4575","455":"399606b7","499":"eeb6d839","728":"ad705ef7","797":"16a6b632","852":"efabf713","859":"e7dc2ffa","936":"d6437bd2","977":"8c72bf08"}[chunkId] + ".chunk.js";
};